import axios from 'axios';
import { customerservice, smsservice } from '../../../../config';

const endpoint = smsservice.uri;
const endpoint2 = customerservice.uri;


export const fetchCustomers = async () => {
  const token = localStorage.getItem("token");
  const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

  const FETCH_CUSTOMERS = `
    query AllCustomers {
      allCustomers {
        id
        customerName
        phoneNumber
        companyName
        companyId
        email
        createdDate
        createdBy
        updatedDate
        updatedBy
        isActive
        creditApproved
      }
    }
  `;

  try {
    const response = await axios.post(endpoint2, {
      query: FETCH_CUSTOMERS
    }, {
      headers: { 'Authorization': formattedToken, 
                'Content-Type': 'application/json',
      },
    });

    const customers = response.data.data.allCustomers; // Access the correct field 'allCustomers'

    if (!customers) {
      throw new Error('No customers found');
    }

    return customers; // Return the customer list directly
  } catch (error) {
    console.error('Error fetching customers:', error.message || error);
    return [];
  }
};

//#region CustomSMS
export const sendCustomSMS = async (message, checkedCustomers) => {
  const token = localStorage.getItem("token");
  const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

  const graphqlQuery = `
    mutation CreateMessage($smsMessage: SmsMessagesInput!) {
      createMessage(smsmessage: $smsMessage) {
        messageId
        phoneNumber
        body
        sentDateTime
        status
        isActive
        statusFlag
        createdBy
        createdDate
        updatedBy
        updatedDate
        companyId
        retries
        apiKey
        apiSubcategoryId
        responseId
        company
        failedReason
      }
    }
  `;

  const smsPromises = checkedCustomers.map(async (customer) => {
    const variables = {
      smsMessage: {
        phoneNumber: customer.phoneNumber, 
        body: message,
      
      }
    };

    try {
      const response = await axios.post(endpoint, {
        query: graphqlQuery,
        variables: variables,
      }, {
        headers: { 'Authorization': formattedToken, 
          'Content-Type': 'application/json',
},
      });

      const result = response.data;

      if (!result.data || result.errors) {
        throw new Error(result.errors ? result.errors[0].message : 'Failed to send SMS');
      }

    } catch (error) {
      console.error(`Error sending SMS to ${customer.phoneNumber}:`, error.message || error);
    }
  });

  await Promise.all(smsPromises);
  alert('Custom SMS batch sent successfully!');
};


export const fetchCustomSMS = async () => {
  const token = localStorage.getItem("token");
  const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

  const FETCH_CUSTOM_SMS = `
    query SmSesByCompany {
      smSesByCompany {
        messageId
        phoneNumber
        body
        sentDateTime
        status
        isActive
        statusFlag
        createdBy
        createdDate
        updatedBy
        updatedDate
        companyId
        retries
        apiKey
        apiSubcategoryId
        responseId
        company
        failedReason
      }
    }
  `;

  try {
    const response = await axios.post(endpoint, {
      query: FETCH_CUSTOM_SMS
    }, {
      headers: { 'Authorization': formattedToken, 
                 'Content-Type': 'application/json',
                },
    });

    const messages = response.data.data.smSesByCompany; // Corrected line

    if (!messages) {
      throw new Error('No messages found');
    }

    return messages; // Return the messages directly
  } catch (error) {
    console.error('Error fetching SMS by company:', error.message || error);
    return [];
  }
};

export const createMessage = async (message, checkedCustomers, currentUserId) => {
  const token = localStorage.getItem("token");
  const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

  const graphqlQuery = `
    mutation CreateMessage($smsMessage: SmsMessagesInput!) {
      createMessage(
        smsmessage: $smsMessage
      ) {
        messageId
        phoneNumber
        body
        sentDateTime
        status
        isActive
        statusFlag
        createdBy
        createdDate
        updatedBy
        updatedDate
        companyId
        retries
        apiKey
        apiSubcategoryId
        responseId
        company
        failedReason
      }
    }
  `;

  const smsPromises = checkedCustomers.map(async (customer) => {
    const variables = {
      smsMessage: { 
        phoneNumber: customer.phoneNumber, 
        body: message, status: message.status,
        statusFlag: message.functionFlag || null, // Handle null for functionFlag
        createdBy: message.createdBy ? parseInt(message.createdBy) : null, 
        companyId: customer.companyId || 'defaultCompanyId' 


 
       
      }
    };

    try {
      const response = await axios.post(endpoint, {
        query: graphqlQuery,
        variables: variables,
      }, {
        headers: { 'Authorization': formattedToken, 
          'Content-Type': 'application/json',
},
      });

      const result = response.data;

      if (!result.data || result.errors) {
        throw new Error(result.errors ? result.errors[0].message : 'Failed to send SMS');
      }

    } catch (error) {
      console.error(`Error sending SMS to ${customer.phoneNumber}:`, error.message || error);
    }
  });

  // Await all promises to resolve
  await Promise.all(smsPromises);
};


export const createSMSesBulk = async (messages) => {
  const token = localStorage.getItem("token");
  const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

  const graphqlQuery = `
    mutation CreateSMSesBulk($smsMessages: [SmsmessagesInput!]!) {
      createSMSesBulk(
        smsmessages: $smsMessages
      ) {
        messageId
        phoneNumber
        body
        sentDateTime
        status
        isActive
        statusFlag
        createdBy
        createdDate
        updatedBy
        updatedDate
        companyId
        retries
        apiKey
        apiSubcategoryId
        responseId
        company
        failedReason
      }
    }
  `;

  // Prepare the messages array for the bulk request
  const smsMessages = messages.map((message) => ({
    phoneNumber: message.phoneNumber, 
    body: message.body,
    status: message.status || null, // Handle undefined or null for status
    statusFlag: message.statusFlag || null, // Handle undefined or null for statusFlag
    createdBy: message.createdBy ? parseInt(message.createdBy) : null, // Convert createdBy to integer if it exists
    companyId: message.companyId || null, // Handle undefined or null for companyId
    apiKey: message.apiKey || null, // Handle undefined or null for apiKey
    apiSubcategoryId: message.apiSubcategoryId || null, // Handle undefined or null for apiSubcategoryId
    retries: message.retries || null, // Handle undefined or null for retries
    responseId: message.responseId || null, // Handle undefined or null for responseId
  }));

  try {
    const response = await axios.post(endpoint, {
      query: graphqlQuery,
      variables: { smsMessages },
    }, {
      headers: { 'Authorization': formattedToken, 
        'Content-Type': 'application/json',
},
    });

    const result = response.data;

    if (!result.data || result.errors) {
      throw new Error(result.errors ? result.errors[0].message : 'Failed to send SMS in bulk');
    }

  } catch (error) {
    console.error('Error sending bulk SMS:', error.message || error);
  }
};


export const editMessage = async (smsData) => {
  const token = localStorage.getItem("token");
  const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

  const EDIT_MESSAGE = `
    mutation EditMessage($smsMessage: SmsMessageInput!) {
      editMessage(smsMessage: $smsMessage) {
        id
        phoneNumber
        body
        sentDateTime
        status
        isActive
        statusFlag
        createdBy
        createdDate
        updatedBy
        updatedDate
        companyId
        retries
        apiKey
        apiSubcategoryId
        responseId
        company
        failedReason
      }
    }
  `;

  try {
    const response = await axios.post(endpoint, {
      query: EDIT_MESSAGE,
      variables: { smsMessage: smsData },
    }, {
      headers: { 'Authorization': formattedToken, 
        'Content-Type': 'application/json',
},
    });

    return response.data.data.editMessage; // Adjust according to your response structure
  } catch (error) {
    console.error('Error editing message:', error.message || error);
    return null;
  }
};
//#endregion


//#region Promotions Data
export const fetchPromotions = async () => {
  const token = localStorage.getItem("token");
  const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

  const graphqlQuery = `
    query Promotion {
      promotion {
        id
        message
        isActive
        companyId
        createdDate
        createdBy
        updatedDate
        updatedBy
      }
    }
  `;

  try {
    const response = await axios.post(endpoint, {
      query: graphqlQuery,
    }, {
      headers: { 'Authorization': formattedToken, 
        'Content-Type': 'application/json',
},
    });

    const result = response.data;

    if (!result.data || result.errors) {
      throw new Error(result.errors ? result.errors[0].message : 'Failed to fetch promotions');
    }

    return result.data.promotion; // Note: changed from result.data.promotions to result.data.promotion
  } catch (error) {
    console.error('Error fetching promotions:', error.message || error);
    return [];
  }
};
export const editPromotion = async (promotion) => {
  const token = localStorage.getItem("token");
  const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

  const graphqlMutation = `
    mutation EditPromotion($promotion: PromotionsInput!) {
      editPromotion(promotion: $promotion) {
        id
        message
        isActive
        companyId
        createdDate
        createdBy
        updatedDate
        updatedBy
      }
    }
  `;

  try {
    const response = await axios.post(endpoint, {
      query: graphqlMutation,
      variables: {
        promotion: {
          id: promotion.id,
          message: promotion.message,
          isActive: promotion.isActive,
          companyId: parseInt(promotion.companyId) || null, // Use provided value or null
          createdDate: promotion.createdDate || null, // Use provided value or null
          createdBy: parseInt(promotion.createdBy) || null, // Use provided value or null
          updatedDate: new Date().toISOString(), // Set to current date
          updatedBy: parseInt('currentUserId'), // Replace with actual user ID
        },
      },
    }, {
      headers: { 'Authorization': formattedToken, 
        'Content-Type': 'application/json',
},
    });

    const result = response.data;

    // Check for errors in the result
    if (!result.data || result.errors) {
      throw new Error(result.errors ? result.errors[0].message : 'Failed to edit promotion');
    }

    return result.data.editPromotion;
  } catch (error) {
    console.error('Error editing promotion:', error.message || error);
    throw error; // Rethrow the error for further handling
  }
};

export const sendPromotionSMS = async (promotionMessage) => {
  const token = localStorage.getItem("token");
  const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

  const graphqlQuery = `
    mutation CreatePromotion($promotion: CreatePromotionInput!) {
      createPromotion(promotion: $promotion) {
        id
        message
        isActive
        companyId
        createdDate
        createdBy
        updatedDate
        updatedBy
      }
    }
  `;

  const variables = {
    promotion: {
      id: null,
      message: promotionMessage,
      isActive: true,
      companyId: null,
      createdDate: new Date().toISOString(),
      createdBy: null,
      updatedDate: new Date().toISOString(),
      updatedBy: null,
    }
  };

  try {
    const response = await axios.post(endpoint, {
      query: graphqlQuery,
      variables: variables,
    }, {
      headers: { 'Authorization': formattedToken, 
        'Content-Type': 'application/json',
},
    });

    const result = response.data;

    if (!result.data || result.errors) {
      throw new Error(result.errors ? result.errors[0].message : 'Failed to create promotion');
    }

    return result.data.createPromotion;
  } catch (error) {
    console.error('Error creating promotion:', error.message || error);
    return null;
  }
};

export const createPromotion = async (promotion) => {
  const token = localStorage.getItem("token");
  const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

  const graphqlMutation = `
    mutation CreatePromotion($promotion: PromotionsInput!) {
      createPromotion(promotion: $promotion) {
        id
        message
        isActive
        companyId
        createdDate
        createdBy
        updatedDate
        updatedBy
      }
    }
  `;

  try {
    const response = await axios.post(endpoint, {
      query: graphqlMutation,
      variables: {
        promotion: {
          message: promotion.message,
          isActive: promotion.isActive,
          companyId: parseInt(promotion.companyId) || null, // Use provided value or null
          createdDate: new Date().toISOString(), // Set to current date for creation
          createdBy: parseInt(promotion.createdBy) || null, // Replace with actual user ID or provided value
        },
      },
    }, {
      headers: { 'Authorization': formattedToken, 
        'Content-Type': 'application/json',
},
    });

    const result = response.data;

    // Check for errors in the result
    if (!result.data || result.errors) {
      throw new Error(result.errors ? result.errors[0].message : 'Failed to create promotion');
    }

    return result.data.createPromotion;
  } catch (error) {
    console.error('Error creating promotion:', error.message || error);
    throw error; // Rethrow the error for further handling
  }
};
export const createAndSendPromotion = async (promotionInput) => {
  const token = localStorage.getItem("token");
  const formattedToken = `Bearer ${token?.replace(/"/g, "")}`;

  const graphqlMutation = `
    mutation CreateAndSendPromotion($input: CreateAndSendInput!) {
      createAndSendPromotion(input: $input) {
        id
        message
        isActive
        companyId
        createdDate
        createdBy
        updatedDate
        updatedBy
      }
    }
  `;

  try {
    const response = await axios.post(endpoint, {
      query: graphqlMutation,
      variables: {
        input: {
          message: promotionInput.message || null,          
          functionFlag: promotionInput.functionFlag || null, 
          customerIds: promotionInput.functionFlag === 1 ? null : promotionInput.customerIds || null, // Set to null if functionFlag is 1, else use customer IDs
          createdBy: promotionInput.createdBy ? parseInt(promotionInput.createdBy) : null, // Convert createdBy to integer or null
        },
      },
    }, {
      headers: {
        'Authorization': formattedToken,
        'Content-Type': 'application/json',
      },
    });

    const result = response.data;

    // Check for errors in the result
    if (!result.data || result.errors) {
      throw new Error(result.errors ? result.errors[0].message : 'Failed to create and send promotion');
    }

    return result.data.createAndSendPromotion;
  } catch (error) {
    console.error('Error creating and sending promotion:', error.message || error);
    throw error; // Rethrow the error for further handling
  }
};
//#endregion

